import React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { DatabaseQuery } from '../../../../../gen-src/queries';
import {
  aboutHeader,
  aboutHeaderDetailsWrapper,
  HorizontalFlexContainer,
  messageForConnectionType,
  SiteUrlsContext
} from '../../../data-catalog-shared';
import {
  AboutHeaderDescriptionDetailItem,
  renderAboutHeaderTagsDetailList,
  renderAboutHeaderTextDetailItem,
  renderEmbeddedAssetDescription,
  renderFileType
} from '../AboutHeaderDetailItems';

type Database = Unpacked<DatabaseQuery['databases']>

export type DatabaseDetailsProps = {
  readonly database: Database;
};

function renderDatabaseType(database: Database) {
  return database.connectionType ?
    renderAboutHeaderTextDetailItem(
      Messages.ConnectionType(), messageForConnectionType(database.connectionType) ?? '', 'database-details-database-type-test-id'
    )
    : null;
}

function renderCategory(database: Database) {
  return database.isGrouped
    ? renderAboutHeaderTextDetailItem(
      Messages.DatabaseCategory(),
      Messages.DatabaseCategoryGroupedDatabase(),
      'database-details-database-category-test-id'
    )
    : null;
}

function renderDetails(database: Database) {
  const element: (JSX.Element | null)[] = [];
  switch (database.__typename) {
    case 'DatabaseServer':
      if (database.hostName) {
        element.push(renderAboutHeaderTextDetailItem(Messages.Hostname(), database.hostName, 'database-details-hostname-test-id'));
      }
      element.push(renderDatabaseType(database));
      break;
    case 'File':
      if (database.filePath) {
        element.push(renderAboutHeaderTextDetailItem(Messages.FilePath(), database.filePath, 'database-details-filepath-test-id'));
      }
      if (database.connectionType) {
        element.push(renderFileType(database.connectionType));
      }
      break;
    case 'CloudFile':
      if (database.connectionType) {
        element.push(renderAboutHeaderTextDetailItem(
          Messages.ConnectionType(), messageForConnectionType(database.connectionType) ?? '', 'database-details-connection-type-test-id'
        ));
      }
      break;
    case 'WebDataConnector':
      if (database.connectorUrl) {
        element.push(renderAboutHeaderTextDetailItem(Messages.WebDataConnectorUrl(), database.connectorUrl,
          'database-details-web-data-connector-url-test-id'));
      }
      element.push(renderAboutHeaderTextDetailItem(Messages.ConnectionType(), Messages.WebDataConnector(),
        'database-details-wdc-connection-type-test-id'));
      break;
    default:
      element.push(renderDatabaseType(database));
  }
  if (database.isEmbedded) {
    element.push(renderEmbeddedAssetDescription('database-asset-details-category-test-id'));
  }
  return element;
}

export function DatabaseDetails(props: DatabaseDetailsProps): JSX.Element {
  return (
    <SiteUrlsContext.Consumer>
      {urls =>
        <div data-tb-test-id={'database-details-wrapper-test-id'} className={aboutHeaderDetailsWrapper}>
          <div className={aboutHeader}>{Messages.About()}</div>
          <div>
            <HorizontalFlexContainer fillFlexParent={true}>
              {renderDetails(props.database)}
              {renderCategory(props.database)}
            </HorizontalFlexContainer>
            {'tags' in props.database ?
              renderAboutHeaderTagsDetailList(props.database, 'database-details-tags-test-id', urls,
                props.database.__typename) : null}
            <AboutHeaderDescriptionDetailItem
              description={props.database.description || ''}
              testId={'database-details-description-test-id'}
            />
          </div>
        </div>
      }
    </SiteUrlsContext.Consumer>
  );
}
